import React from "react";
import Typography from "../../../../Foundation/Typography/Typography";
import htmlParse from "html-react-parser";
import clsx from "clsx";
import { _LandingAboutMargauxMotinRoot } from "./LandginAboutMargauxMotin.styled";
import { _LandingAboutRoot } from "../LandingAbout.styled"; 
import DecorationBox from "../../../DecorationBox/DecorationBox";
import FlexBox from "../../../FlexBox/FlexBox";
import StyledDiv from "../../../StyledDiv/StyledDiv";

interface ILandingAboutMargauxMotinProps {
  description?: string;
}
const LandingAboutMargauxMotin = (props: ILandingAboutMargauxMotinProps) => {
  const { description } = props;
  return (
    <_LandingAboutMargauxMotinRoot>
      <StyledDiv
        as={_LandingAboutRoot}
        styles={{
          padding: "24px",
          lg: {
            padding: "0px 0",
          },
        }}
        id="landing-about-margaux-motin"
        className="landing-about-margaux-motin"
      >
        <div className={clsx("landing-about__container without-image")}>
          <div className="landing-about__right">
            <FlexBox
              direction="row"
              gap={98}
              className="landing-about__inner-wrapper"
            >
              <DecorationBox
                className="girl-opening-box-decoration"
                imageName="girlOpeningBox"
                alt="girl-opening-box"
                enableAnimation={true}
                animationType="slideRight"
                animationDelay={300}
                animationDistance={500}
                threshold={0.7}
              />
              <div className="landing-about__description__container">
                <DecorationBox
                  imageName="sushishopXMargauxMotin"
                  alt="sushishop-x-margaux-motin"
                  className="sushishop-x-margaux-motin-decoration"
                />
                <Typography
                  variant={"body"}
                  className="landing-about__description"
                  style={{
                    lineHeight: "140%",
                    letterSpacing: "-0.17px",
                  }}
                >
                  {htmlParse(description + "")}
                </Typography>
              </div>
              <DecorationBox
                imageName="skateboarding"
                alt="skateboarding"
                className="skateboarding-decoration"
                enableAnimation={true}
                animationType="slideLeft"
                animationDelay={600}
                animationDistance={500}
                threshold={0.7}
              />
            </FlexBox>
          </div>
        </div>
      </StyledDiv>
    </_LandingAboutMargauxMotinRoot>
  );
};

export default LandingAboutMargauxMotin;
